export const iconFontAwesomeHumanitarianRug = (
	<i className="fa-solid fa-rug"></i>
);
